import React from "react";

const FeedbackSection = ({ course }) => {

    const renderStars = (rating) => {
        return [...Array(5)].map((_, i) => (
            <svg
                key={i}
                className={`w-5 h-5 ${i < rating ? "text-yellow-400" : "text-gray-300"}`}
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path d="M9.049 2.927C9.3 2.165 10.7 2.165 10.951 2.927L12.3 6.97L16.588 7.013C17.392 7.02 17.724 8.053 17.083 8.514L13.651 11.02L14.9 15.07C15.131 15.838 14.23 16.45 13.553 15.97L10 13.6L6.447 15.97C5.77 16.45 4.869 15.838 5.1 15.07L6.349 11.02L2.917 8.514C2.276 8.053 2.608 7.02 3.412 7.013L7.7 6.97L9.049 2.927Z" />
            </svg>
        ));
    };

    return (
        <div>
            {course.feedback && course.feedback.length > 0 && (
                <div className="mt-14">

                    {/* Title */}
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="font-semibold mb-4 flex items-center gap-2">
                            Student Feedback
                        </h2>

                        <span className="text-sm text-gray-500">
                            {course.feedback.length} Reviews
                        </span>
                    </div>

                    {/* Feedback Grid */}
                    <div className="grid md:grid-cols-2 gap-6">

                        {course.feedback.map((fb, index) => (

                            <div
                                key={index}
                                className="bg-white border rounded-xl p-5 shadow-sm hover:shadow-md transition duration-300"
                            >

                                {/* Top */}
                                <div className="flex items-center justify-between mb-3">

                                    <div className="flex items-center gap-3">

                                        {/* Avatar */}
                                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 font-semibold text-gray-700">
                                            {fb.name?.charAt(0) || "A"}
                                        </div>

                                        <div>
                                            <p className="font-medium text-gray-900">
                                                {fb?.name || "Anonymous"}
                                            </p>

                                            <p className="text-xs text-gray-400">
                                                {new Date(fb.createdAt).toLocaleDateString()}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Rating */}
                                    <div className="flex">
                                        {renderStars(fb.rating)}
                                    </div>
                                </div>
                                {/* Review Text */}
                                <p className="text-gray-600 text-sm leading-relaxed">
                                    {fb.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FeedbackSection;